import { t } from 'i18next'
import { Highlight, connectRefinementList } from 'react-instantsearch-dom'
import './Brands.scss'

const highlightStyle = {
  backgroundColor: 'rgba(0, 140, 255, 0.1)',
  color: '#008CFF',
  border: '1px solid #008CFF',
}

const normalStyle = {
  backgroundColor: '#FFFFFF',
  color: '#232A2D',
  border: '1px solid #D5D8DF',
}

const RefinementList = ({
  items,
  isFromSearch,
  refine,
  createURL,
}: {
  items: any
  isFromSearch: any
  refine: any
  createURL: any
}) => (
  <div className="brands_container">
    <div className="brandLabel">{t('brands')}</div>
    <ul className="brands">
      {items.map((item: any) => {
        return (
          <a
            key={item.value}
            href={createURL(item.value)}
            onClick={event => {
              event.preventDefault()
              refine(item.value)
            }}
          >
            {isFromSearch ? (
              <Highlight attribute="label" hit={item} />
            ) : (
              <li
                className="brand"
                key={item.label}
                style={item.isRefined ? highlightStyle : normalStyle}
              >
                {item.label}
              </li>
            )}
          </a>
        )
      })}
    </ul>
  </div>
)

const RefinedBrands = connectRefinementList(RefinementList)

export default RefinedBrands
